import { useEffect, useState } from 'react';

/**
 * Active section tab of the article editor: smooth scroll on click and scroll spy.
 */
export function useSectionScrollSpy(hasBibliography) {
  const [activeMainTab, setActiveMainTab] = useState('overview');

  // Pexels integration removed - now handled by backend worker
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
      setActiveMainTab(sectionId);
    }
  };

  // Scroll spy to update active tab based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['overview', 'metadata', 'faq', ...(hasBibliography ? ['bibliography'] : [])];
      const scrollPosition = window.scrollY + 100; // Offset for sticky header

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(sections[i]);
        if (element && element.offsetTop <= scrollPosition) {
          setActiveMainTab(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasBibliography]);

  return { activeMainTab, scrollToSection };
}
